import { makeAutoObservable } from 'mobx';

import type { useFlagsCombination } from '@src/utility/useFlagsCombination';

/**
 * The resolved flags type, derived from the return type of useFlagsCombination.
 */
export type FeatureFlags = ReturnType<typeof useFlagsCombination>;

/**
 * Centralized MobX store for feature flags.
 *
 * Instead of calling useFlagsCombination() in every component (which triggers
 * LaunchDarkly hook + resolution per mount), this store holds the resolved
 * flags as observable state. The StoreProvider updates it once when
 * LaunchDarkly context changes, and all consumers read from the single
 * observable store via useFeatureFlags().
 */
export class FeatureFlagsStore {
  private _flags: Partial<FeatureFlags> = {};

  constructor() {
    makeAutoObservable(this);
  }

  get flags(): Partial<FeatureFlags> {
    return this._flags;
  }

  /**
   * Update all flags. Called from StoreProvider when useFlagsCombination resolves new values.
   */
  setFlags(flags: FeatureFlags): void {
    this._flags = flags;
  }
}
